import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'tw',
    alia: 'zh',
    region: 'China',
    regionText: '台灣地區',
    language: 'Chinese',
    languageText: '繁体中文',
    appId: 19,
    acceptLanguage: 'zh_TW,zh;q=0.9', //暂定
};
export default theLocale;
